import { styled, Card } from '@mui/material';
import { lighten } from '@mui/material/styles';

export const DialogConfigAndPreferencesSectionCard = styled(Card, {
  shouldForwardProp: (prop) =>
    prop !== 'isDanger' && prop !== 'withBackGround' && prop !== 'small',
})<{ isDanger?: boolean; withBackGround?: boolean; small?: boolean }>(
  ({ theme, isDanger, withBackGround, small }) => ({
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,

    ...(isDanger && {
      border: `1px solid ${theme.palette.error.light}`,

      ...(withBackGround && {
        backgroundColor: lighten(theme.palette.error.light, 0.9),
      }),
    }),

    ...(small && {
      padding: theme.spacing(1),
    }),
  }),
);
